<div id="chart" #chart style="height:100%; width:100%;"></div>
<!-- <div id="dataset-picker"></div> -->